
// let categoryData = ['原煤', '天然气', '原油', '一次电力', '汽油', '柴油'];
// let chartdata = [1111, 11111, 1111, 1111, 22222, 2222];

// var option = {
//     color: ['#00D7E9', 'rgba(0, 215, 233, 0.9)'],
//     tooltip: {
//         trigger: 'axis',
//         formatter: '{b}:{c0}',
//     },
//     title:{
//         text:"按维修器材统计",
//         top:8,
//         left:8
//     },
//     grid: {
//         left: '12%',
//         top: '15%',
//         bottom: '12%',
//         right: '8%'
//     },
//     xAxis: {
//         nameTextStyle: {
//             color: '#c0c3cd',
//             padding: [0, 0, -10, 0],
//             fontSize: 14,
//         },
//         textStyle: {
//             color: '#999',
//             fontSize: 12
//         },
//         axisTick: {
//             show: false,
//             lineStyle: {
//                 color: '#384267',
//                 width: 1,
//             },
//         },
//         splitLine: {
//             show: false,
//         },
//         axisLine: {
//             lineStyle: {
//                 color: '#335971',
//             },
//             show: true,
//         },
//         data: categoryData,
//         type: 'category',
//     },
//     yAxis: {
//         nameTextStyle: {
//             color: '#c0c3cd',
//             padding: [0, 0, -10, 0],
//             fontSize: 14,
//         },
//         textStyle: {
//             color: '#999',
//             fontSize: 12
//         },
//         axisTick: {
//             lineStyle: {
//                 color: '#668092',
//                 width: 1,
//             },
//             show: true,
//         },
//         splitLine: {
//             show: true,
//             lineStyle: {
//                 color: '#335971',
//                 // "type": "dashed"
//             },
//         },
//         axisLine: {
//             lineStyle: {
//                 color: '#668092',
//                 width: 1,
//                 // "type": "dashed"
//             },
//             show: true,
//         },
//         name: '',
//     },
//     series: [
//         {
//             data: chartdata,
//             type: 'bar',
//             barMaxWidth: 'auto',
//             barWidth: 20,
//             itemStyle: {
//                 color: {
//                     x: 0,
//                     y: 1,
//                     x2: 0,
//                     y2: 0,
//                     type: 'linear',
//                     colorStops: [
//                         {
//                             offset: 0,
//                             color: '#00D7E9',
//                         },
//                         {
//                             offset: 1,
//                             color: 'rgba(0, 167, 233,0.3)',
//                         },
//                     ],
//                 },
//             },
//             label: {
//                 show: true,
//                 position: 'top',
//                 distance: 10,
//                 color: '#08DFFE',
//             },
//         },
//         {
//             data: [1, 1, 1, 1, 1, 1],
//             type: 'pictorialBar',
//             barMaxWidth: '20',
//             symbol: 'diamond',
//             symbolOffset: [0, '50%'],
//             symbolSize: [20, 10],
//         },
//         {
//             data: chartdata,
//             type: 'pictorialBar',
//             barMaxWidth: '20',

//             symbolPosition: 'end',
//             symbol: 'diamond',
//             symbolOffset: [0, '-50%'],
//             symbolSize: [20, 12],
//             zlevel: 2,
//         },
//     ],
// };


// export default option;

import * as echarts from 'echarts';
var option = {
    title: {
        text: "按器材统计",
        top: 8,
        left: 8,
        textStyle: {
            color: "#ffffff"
        }
    },
    grid: {
        left: '12%',
        top: '15%',
        bottom: '12%',
        right: '8%'
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    xAxis: {
        data: [],
        axisTick: {
            show: false
        },
        axisLine: {
            lineStyle: {
                color: 'rgba(255, 129, 109,.1)',
                width: 1 //这里是为了突出显示加上的
            }
        },
        axisLabel: {
            textStyle: {
                color: '#ffffff',
                fontSize: 12
            }
        }
    },
    yAxis: [{
        axisTick: {
            show: false
        },
        axisLine: {
            lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 1 //这里是为了突出显示加上的
            }
        },
        axisLabel: {
            textStyle: {
                color: '#ffffff'
            }
        },
        splitArea: {
            areaStyle: {
                color: 'rgba(255,255,255,.5)'
            }
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: 'rgba(255, 129, 109, 0.1)',
                width: 0.5,
                type: 'dashed'
            }
        }
    }
    ],
    series: [

    ]
};

option.configItem = function () {
    return {
        name: '',
        type: 'bar',
        stack: '故障',
        barWidth: 20,
        itemStyle: {
            barBorderRadius: 20,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(55,255,249,1)"
            },
            {
                offset: 1,
                color: "rgba(0,222,215,0.2)"
            }
            ])
        },
        data: []
    };
}

option.configColor = function () {
    return [
        {
            barBorderRadius: 20,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(55,255,249,1)"
            },
            {
                offset: 1,
                color: "rgba(0,222,215,0.2)"
            }
            ])
        },
        {
            barBorderRadius: 20,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(255,252,0,1)"
            },
            {
                offset: 1,
                color: "rgba(8,228,222,0.2)"
            }
            ])
        },

    ]
}

export default option;